// extracted by mini-css-extract-plugin
export var container = "_5w-1";
export var cornerButtonContainer = "_5w-6";
export var disabled = "_5w-2";
export var dragActive = "_5w-3";
export var fileContainer = "_5w-5";
export var hiddenInput = "_5w-4";
export var widthContainer = "_5w-0";